import { useEffect } from 'react';
import { useInfiniteHits } from 'react-instantsearch';
const useInfiniteResults = function (ref) {
  let autoScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const {
    hits,
    isLastPage,
    showMore
  } = useInfiniteHits();

  // Load new hits automatically on scroll when autoScroll is enabled.
  useEffect(() => {
    if (!autoScroll || hits.length === 0) {
      return () => {};
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLastPage) {
          showMore();
        }
      });
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref, isLastPage, showMore, autoScroll, hits]);
  return {
    hits,
    isLastPage,
    showMore
  };
};
export default useInfiniteResults;